import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {

  constructor() {
    this.currentData.subscribe((data) => {      
    });
   }
  private modelDataSource = new BehaviorSubject<any>({});
  currentData = this.modelDataSource.asObservable();

  changeData(data: any) {
    this.modelDataSource.next(data);
  }
}
